import React from 'react';
import { Link } from 'gatsby';
import { isExternalLink } from '@utils';

const withLink = Component => {
  const ComponentWithLink = props => {
    const { to, title } = props;

    if (!to) {
      return <Component {...props} />;
    }

    if (isExternalLink(to)) {
      return (
        <Component
          as="a"
          href={to}
          title={title}
          target="_blank"
          rel="noopener noreferrer"
          {...props}
        />
      );
    }

    return <Component as={Link} activeClassName="link-active" {...props} />;
  };

  return ComponentWithLink;
};

export default withLink;
